import { LOCALES } from 'i18n/locales';

export const organisationModalIntl = {
    [LOCALES.ENGLISH]: {
        'organisationModal.title': 'Choose Organisation',
        'organisationModal.choiceLabel': 'Organisation',
        'organisationModal.chooseOption': 'Choose an organisation',
        'organisationModal.message': 'Choose from a list of organisations associated with your account',
        'organisationModal.continueButtonLabel': 'Continue'
    },
    [LOCALES.WELSH]: {
        'organisationModal.title': 'Dewis Sefydliad',
        'organisationModal.choiceLabel': 'Sefydliad',
        'organisationModal.chooseOption': 'Dewis sefydliad',
        'organisationModal.message': 'Dewiswch o blith rhestr o sefydliadau sy\'n gysylltiedig â\'ch cyfrif',
        'organisationModal.continueButtonLabel': 'Parhau'
    }
};
